import { ReactNode } from "react"
import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"

export enum MeetingTimeLeftVariant {
    GREEN = "green",
    YELLOW = "yellow",
    RED = "red",
}

const useStyles = makeStyles()((theme) => ({
    tag: {
        display: "inline-flex",
        alignItems: "center",
        gap: ".5rem",
        padding: ".25rem .625rem",
        borderRadius: "6.25rem",
        fontWeight: 500,
        fontSize: ".875rem",
        whiteSpace: "nowrap",
    },
    dot: {
        width: ".5rem",
        height: ".5rem",
        borderRadius: "50%",
        flexShrink: 0,
    },
    green: {
        background: theme.palette.tailwind.green[100],
        color: theme.palette.tailwind.green[600],
    },
    yellow: {
        background: theme.palette.tailwind.amber[100],
        color: theme.palette.tailwind.amber[600],
    },
    red: {
        background: theme.palette.tailwind.red[100],
        color: theme.palette.tailwind.red[600],
    },
    dotGreen: {
        background: theme.palette.tailwind.green[600],
    },
    dotYellow: {
        background: theme.palette.tailwind.amber[500],
    },
    dotRed: {
        background: theme.palette.tailwind.red[600],
    },
}))

type Props = Readonly<{
    variant: MeetingTimeLeftVariant
    children: ReactNode
    className?: string
}>

export function MeetingTimeLeftTag({ variant, children, className }: Props) {
    const { classes, cx } = useStyles()

    const variantClasses: Record<MeetingTimeLeftVariant, { tag: string; dot: string }> = {
        [MeetingTimeLeftVariant.GREEN]: { tag: classes.green, dot: classes.dotGreen },
        [MeetingTimeLeftVariant.YELLOW]: { tag: classes.yellow, dot: classes.dotYellow },
        [MeetingTimeLeftVariant.RED]: { tag: classes.red, dot: classes.dotRed },
    }

    return (
        <Box className={cx(classes.tag, variantClasses[variant].tag, className)}>
            <Box className={cx(classes.dot, variantClasses[variant].dot)} />
            {children}
        </Box>
    )
}
